import { create, all } from "mathjs";
import { valueTypes } from "utils/builder/ResultClasses";
import DateError from "utils/customErrors/dateError";

function RoundUp(value) {
  return math.ceil(value);
}

function RoundDown(value) {
  return math.fix(value);
}

function Round(value) {
  return math.round(value);
}

function Min(...args) {
  return math.min(args);
}

function Max(...args) {
  return math.max(args);
}

function SubtractingDates(...args) {
  const firstDate = new Date( args[0]);
  const secondDate = new Date(args[1]);
  const diffTime = secondDate - firstDate;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if (!diffDays) {
    throw new DateError("Not valid dates")
  }
  return diffDays
}

const math = create(all);

math.import({
  RoundUp,
  RoundDown,
  Round,
  Min,
  Max,
  SubtractingDates,
});

export class ComputeService {
  static executeFunction(
    { 
      headers,
      rows,
      totals,
      conditionScheme,
      types
    }) {
      if (!conditionScheme?.columnCondition || !conditionScheme?.newColumnName ) {
        return {
          updateHeaders: headers,
          updatedRows: rows,
          updatedTotals: totals,
          updatedTypes: types,
        };
    }

    const updateHeaders = [...headers, conditionScheme.newColumnName];

    let updatedTypes = types;
    let newTotalValue = null;

    const updatedRows = rows.map((row, index) => {
      try {
        const mathScopeObj = {};
        for (const key in conditionScheme.variables) {
          mathScopeObj[key] = row.lines[conditionScheme.variables[key]];
        }

        const newRowValue = math.evaluate(
          conditionScheme.columnCondition,
          mathScopeObj
        );

        if (index === 0) {
          const type = typeof newRowValue;
          updatedTypes = [...updatedTypes, valueTypes[type]];
        }

        newTotalValue = newTotalValue === null ? newRowValue : newTotalValue + newRowValue

        const updatedLines = [...row.lines, newRowValue];

        return { ...row, lines: updatedLines };

      } catch (error) {

        if (index === 0) {
          updatedTypes = [...updatedTypes, valueTypes["number"]];
        }
        const currentErrorMessage = error.name !== "DateError" ? error.message : '';
        const updatedLines = [...row.lines, currentErrorMessage];
        return { ...row, lines: updatedLines };
      }

    });

    const updatedTotals = [...totals, newTotalValue];

    return {
      updateHeaders: updateHeaders,
      updatedRows: updatedRows,
      updatedTotals: updatedTotals,
      updatedTypes: updatedTypes,
    };
  }

  static executeFunctions({ headers, rows, totals, columnSchemes, types }) {
    if (!columnSchemes) {
      return {
        updateHeaders: headers,
        updatedRows: rows,
        updatedTotals: totals,
        updatedTypes: types,
      };
    }
  
    let currentUpdatedData = {
      updateHeaders: headers,
      updatedRows: rows,
      updatedTotals: totals,
      updatedTypes: types,
    }

    for (const key in columnSchemes) {
        const conditionScheme = columnSchemes[key]
        const newData = ComputeService.executeFunction({
          headers: currentUpdatedData.updateHeaders,
          rows: currentUpdatedData.updatedRows,
          totals: currentUpdatedData.updatedTotals,
          conditionScheme,
          types: currentUpdatedData.updatedTypes,
        });
  
        currentUpdatedData.updateHeaders = newData.updateHeaders;
        currentUpdatedData.updatedRows = newData.updatedRows;
        currentUpdatedData.updatedTotals = newData.updatedTotals;
        currentUpdatedData.updatedTypes = newData.updatedTypes;
    }
    
    return currentUpdatedData;
  }
}
